/* RESPONSIBLE TEAM: team-phone */

export type FinVoiceVoiceLanguageOptions = {
  value: FinVoiceVoiceLanguage;
  text: string;
};

export type FinVoiceVoiceLanguage =
  | 'ar-AE'
  | 'bg-BG'
  | 'zh-CN'
  | 'cs-CZ'
  | 'da-DK'
  | 'nl-NL'
  | 'en-US'
  | 'fi-FI'
  | 'fr-FR'
  | 'de-DE'
  | 'el-GR'
  | 'hi-IN'
  | 'hu-HU'
  | 'id-ID'
  | 'it-IT'
  | 'ja-JP'
  | 'ko-KR'
  | 'ms-MY'
  | 'no-NO'
  | 'pl-PL'
  | 'pt-PT'
  | 'ro-RO'
  | 'ru-RU'
  | 'es-ES'
  | 'sv-SE'
  | 'ta-IN'
  | 'tr-TR'
  | 'uk-UA'
  | 'vi-VN';

export const FIN_VOICE_VOICE_LANGUAGE_OPTIONS: FinVoiceVoiceLanguageOptions[] = [
  { value: 'ar-AE', text: 'app.lib.languages.language.ar' },
  { value: 'bg-BG', text: 'app.lib.languages.language.bg' },
  { value: 'pt-PT', text: 'app.lib.languages.language.pt' },
  { value: 'zh-CN', text: 'app.lib.languages.language.zh-CN' },
  { value: 'cs-CZ', text: 'app.lib.languages.language.cs' },
  { value: 'da-DK', text: 'app.lib.languages.language.da' },
  { value: 'fi-FI', text: 'app.lib.languages.language.fi' },
  { value: 'de-DE', text: 'app.lib.languages.language.de' },
  { value: 'el-GR', text: 'app.lib.languages.language.el' },
  { value: 'en-US', text: 'app.lib.languages.language.en' },
  { value: 'es-ES', text: 'app.lib.languages.language.es' },
  { value: 'fr-FR', text: 'app.lib.languages.language.fr' },
  { value: 'hi-IN', text: 'app.lib.languages.language.hi' },
  { value: 'hu-HU', text: 'app.lib.languages.language.hu' },
  { value: 'id-ID', text: 'app.lib.languages.language.id' },
  { value: 'it-IT', text: 'app.lib.languages.language.it' },
  { value: 'ja-JP', text: 'app.lib.languages.language.ja' },
  { value: 'ko-KR', text: 'app.lib.languages.language.ko' },
  { value: 'ms-MY', text: 'app.lib.languages.language.ms' },
  { value: 'nl-NL', text: 'app.lib.languages.language.nl' },
  { value: 'no-NO', text: 'app.lib.languages.language.nb' },
  { value: 'pl-PL', text: 'app.lib.languages.language.pl' },
  { value: 'ro-RO', text: 'app.lib.languages.language.ro' },
  { value: 'ru-RU', text: 'app.lib.languages.language.ru' },
  { value: 'sv-SE', text: 'app.lib.languages.language.sv' },
  { value: 'ta-IN', text: 'app.lib.languages.language.ta' },
  { value: 'tr-TR', text: 'app.lib.languages.language.tr' },
  { value: 'uk-UA', text: 'app.lib.languages.language.uk' },
  { value: 'vi-VN', text: 'app.lib.languages.language.vi' },
];

export const DEFAULT_VOICE_LANGUAGE = 'en-US';
